{
  "default": {
    "DOSSIER_NUMBER": "N Pratica:",
    "DISCHARGE_DATE": "Data dimissione"
  },
  "ALTRO": {
    "DOSSIER_NUMBER": "N Pratica:",
    "DISCHARGE_DATE": "Data di dimissione prevista"
  },
  "HCP": {
    "DOSSIER_NUMBER": "Pratica Hospice:",
    "DISCHARGE_DATE": "Data di dimissione prevista"
  },
  "ADI": {
    "DISCHARGE_DATE": "Data chiusura intervento"
  },
  "26": {

  },
  "PA": {

  },
  "RSA": {

  }
}
